import * as React from 'react';
import * as request from 'superagent';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import AppView from '~common/components/app-view/index';
import LoadingView from '~common/components/loading-view';
import ErrorView from '~common/components/error-view';
import PortalUserSubscription from '~common/lib/models/portal-user-subscription';
import {Paper, Link} from '@mui/material';
import {Typography} from '@mui/material';




const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	history: any;
	location: any;
}

type State = {
	status: 'ready' | 'loading';
	error?: any;
};

class UnsunscribeView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			status: 'loading',
		};
	}

	componentDidMount() {
		const {match} = this.props;
		request.get(`/api/portal-user-subscriptions/unsubscribe-init/${match.params.id}`).then((response: request.Response)=>{
			this.setState({
				status: "ready",
				subscription: response.body.subscription,
				unsubscribed: response.body.subscription.status == "Active" ? false : true,
				prior: response.body.subscription.status == "Active" ? false : true
			})
		}).catch((err)=>{
			this.handleAPIError(err)
		})
	}


    handleAPIError = (err: any, terminal?: boolean) => {
		this.setState({
			status: "redady",
			unsubscribing: false,
			error: err
		})
	};


    handleErrorClose = () => {
        this.setState({error:undefined})
    }

	handleUnsubscribe = () => {
		const {match} = this.props;
		if (!this.state.unsubscribing) {
			this.setState({
				unsubscribing: true
			}, ()=>{
				request.put(`/api/portal-user-subscriptions/unsubscribe/${match.params.id}`).then((response: request.Response)=>{
					this.setState({unsubscribing: false, unsubscribed: true})
				}).catch((err)=>{
					this.handleAPIError(err)
				})
			})
		}
	}

	render() {

		const { classes }: { classes: ClassNameMap } = this.props;
		const { status, subscription, error, unsubscribing, unsubscribed, prior } = this.state;
	

		if (status == 'loading') {
            if (error) {
                return <ErrorView classes={{}} onClose={this.handleErrorClose} error={error} />
            }
			return <LoadingView classes={{}} />;
		}

		var spinner: any;
		if (unsubscribing) {
			spinner = <LoadingView className={classes.spinner} overlay classes={{}} />
		}
	
		return (
			<div className={classes.container}>
				<AppView history={this.props.history}>
					{spinner}
                    {error && <ErrorView classes={{}} onClose={this.handleErrorClose} error={error} />}
					<Paper elevation={0}>
						{!unsubscribed && subscription && <div>
							<Typography variant="h5" style={{textAlign: 'center', marginTop: 20}}>
								Are you sure you want to unsubscribe from {subscription.name}?
							</Typography>
							<Typography variant="h5" style={{textAlign: 'center', marginTop: 20}}>
								Click <Link
									component="span"
									onClick={this.handleUnsubscribe}
									underline="hover"
									sx={{ color: 'blue', cursor: "pointer" }}
									>
									here
									</Link>{" "} to unsubscribe.
							</Typography>
						</div>}
						{unsubscribed && 
							<div>
								{!prior && <Typography variant="h5" style={{textAlign: 'center', marginTop: 20}}>You have been unsubscribed from {subscription.name}. </Typography>}
								{prior && <Typography variant="h5" style={{textAlign: 'center', marginTop: 20}}>You previously unsubscribed from {subscription.name}. </Typography>}
							</div>
						}
					</Paper>
				</AppView>
			</div>
		);
	}
}

export default withStyles(styles)(UnsunscribeView);
